import { TagERP, TagType } from "@finanedi.es/storybook"
import {
  faCircleCheck,
  faCircleXmark,
  faClock,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  ESTADO_APROBACION_TICKET,
  EstadoAprobacionTicketType,
} from "api/Types/EstadoAprobacionTicket"
import { t } from "i18next"

export const EstadoRevisionActual = (
  estadoRevisionActual: EstadoAprobacionTicketType,
  id?: string
) => {
  const ESTADO_REVISION_PROPERTIES: Record<
    EstadoAprobacionTicketType,
    {
      icon: React.ReactNode
      color: TagType
      text: string
    }
  > = {
    [ESTADO_APROBACION_TICKET.PENDIENTE]: {
      icon: <FontAwesomeIcon icon={faClock} />,
      color: "alternativeOne",
      text: t("filters.estadoRevision.pendingLabel"),
    },
    [ESTADO_APROBACION_TICKET.APROBADO]: {
      icon: <FontAwesomeIcon icon={faCircleCheck} />,
      color: "success",
      text: t("filters.estadoRevision.validateLabel"),
    },
    [ESTADO_APROBACION_TICKET.RECHAZADO]: {
      icon: <FontAwesomeIcon icon={faCircleXmark} />,
      color: "danger",
      text: t("filters.estadoRevision.rejectedLabel"),
    },
  }
  const { icon, color, text } =
    (estadoRevisionActual &&
      ESTADO_REVISION_PROPERTIES[estadoRevisionActual]) ||
    {}

  return (
    <div className='tw-flex tw-justify-center tw-items-center !tw-w-full'>
      <TagERP
        id={id}
        value={text}
        color={color}
        icon={icon}
      />
    </div>
  )
}
